export const experiences = [
  {
    id: 'promillys',
    company: 'PROMILLYS',
    year: '2024',
    period: '15 Mars 2024 - Présent',
    periodEn: 'March 15, 2024 - Present',
    location: 'Yaoundé, Cameroun',
    locationEn: 'Yaoundé, Cameroon',
    position: 'Développeur Fullstack',
    positionEn: 'Fullstack Developer',
    description: [
      "Réalisation d'un projet CRM et ERP avec NEXT JS et LARAVEL",
      'Formation et intégration des nouveaux développeur web',
      "Intégration de l'API d'OpenAI et réalisation d'une application web d'intelligence artificielle basée sur ChatGPT pour la génération de contenu et d'images",
      'Réalisation de site Web avec WordPress',
    ],
    descriptionEn: [
      'Built a CRM and ERP project with Next.js and Laravel',
      'Trained and onboarded new web developers',
      'Integrated the OpenAI API and built a ChatGPT-based AI web app for content and image generation',
      'Delivered websites with WordPress',
    ],
  },
  {
    id: 'nebulageek',
    company: 'Nebulageek',
    year: '2024',
    period: '6 mois',
    periodEn: '6 months',
    location: 'Canada (Remote)',
    locationEn: 'Canada (Remote)',
    position: 'Développeur Fullstack',
    positionEn: 'Fullstack Developer',
    description: [
      'Développement freelance pour une entreprise canadienne spécialisée dans le développement web',
      "Création et maintenance d'applications web modernes avec focus sur l'UX et les performances",
      'Technologies utilisées : React.js, Node.js, Tailwind CSS',
    ],
    descriptionEn: [
      'Freelance development for a Canadian web development company',
      'Built and maintained modern web applications with a focus on UX and performance',
      'Technologies: React.js, Node.js, Tailwind CSS',
    ],
  },
  {
    id: 'ets-noeli',
    company: 'ETS Noeli',
    year: '2021–23',
    period: 'Février 2021 - Juillet 2023',
    periodEn: 'February 2021 - July 2023',
    location: 'Yaoundé, Cameroun',
    locationEn: 'Yaoundé, Cameroon',
    position: 'Développeur Fullstack & UI/UX Designer',
    positionEn: 'Fullstack Developer & UI/UX Designer',
    description: [
      'Développeur certifié Salesforce',
      'Développeur certifié Javascript',
      'Développeur React Js',
      'Développeur junior Node js',
      'UI/UX Designer',
    ],
    descriptionEn: [
      'Salesforce certified developer',
      'JavaScript certified developer',
      'React.js developer',
      'Junior Node.js developer',
      'UI/UX designer',
    ],
  },
  {
    id: 'quickyy',
    company: 'Quickyy.net',
    year: '2021',
    period: 'Mars 2021 - Août 2021',
    periodEn: 'March 2021 - August 2021',
    location: 'Cameroun (Remote)',
    locationEn: 'Cameroon (Remote)',
    position: 'Senior Community Manager',
    positionEn: 'Senior Community Manager',
    description: [
      'Gestion stratégique des réseaux sociaux et de la présence digitale',
      'Développement et mise en œuvre de stratégies marketing digital',
      'Gestion des campagnes publicitaires sur Facebook for Business',
      'Analyse des performances et optimisation des contenus',
      'Compétences : Digital Marketing, Facebook for Business, Social Media Marketing, Digital Strategy',
    ],
    descriptionEn: [
      'Strategic management of social media and digital presence',
      'Developed and executed digital marketing strategies',
      'Managed advertising campaigns on Facebook for Business',
      'Analyzed performance and optimized content',
      'Skills: Digital Marketing, Facebook for Business, Social Media Marketing, Digital Strategy',
    ],
  },
  {
    id: 'cleandev-orelextech',
    company: 'CleanDev SARL et OrelexTech SARL',
    year: 'Stage',
    yearEn: 'Internship',
    period: 'Stage académique et Professionnel',
    periodEn: 'Academic and professional internship',
    location: 'Yaoundé, Cameroun',
    locationEn: 'Yaoundé, Cameroon',
    position: 'Développeur Web FullStack',
    positionEn: 'Fullstack Web Developer',
    description: [
      "À CleanDev SARL: Réalisation d'un site web de vente en ligne pour permettre aux petites et moyennes entreprises d'étendre leur activité commerciale",
      "À OrelexTech SARL: Conception et réalisation d'une application de gestion des stagiaires pour une entreprise",
    ],
    descriptionEn: [
      'At CleanDev SARL: Built an e-commerce website to help SMEs expand their commercial activity',
      'At OrelexTech SARL: Designed and built an intern management application for a company',
    ],
  },
  {
    id: 'ict-business-center',
    company: 'ICT Business Center',
    year: '2018–20',
    period: 'Décembre 2018 - Décembre 2020',
    periodEn: 'December 2018 - December 2020',
    location: 'Yaoundé, Cameroun',
    locationEn: 'Yaoundé, Cameroon',
    position: 'Développeur Web FullStack',
    positionEn: 'Fullstack Web Developer',
    description: [
      'Intégrateur de maquettes web (HTML, CSS, Bootstrap, React Js...)',
      'Implémentation de la logique métier avec du php',
      'Analyses des besoins fonctionnels et non fonctionnels des clients',
      'Design de maquettes avec Figma',
    ],
    descriptionEn: [
      'Web mockup integration (HTML, CSS, Bootstrap, React.js...)',
      'Implemented business logic with PHP',
      'Analyzed client functional and non-functional requirements',
      'Designed mockups with Figma',
    ],
  },
];

export const pickLocalizedField = (item, lang, key) => {
  const localizedKey = `${key}En`;
  if (lang === 'en' && item[localizedKey]) return item[localizedKey];
  return item[key];
};
